<template>
  <div class="absolute top-0 w-full h-full text-center">
    <welcome-to-scan :title="$t('homePage.firstScanTitle')" />
    <panel class="btn-wrapper">
      <div
        class="btn relative mx-auto mt-10 md:mt-20 w-40 h-40 flex justify-center items-center"
        @click="$emit('scan')"
      >
        <img class="img-1 breathing" src="@/assets/HoverButton/main-1.svg" />
        <img class="img-2 breathing" src="@/assets/HoverButton/main-2.svg" />
        <img class="img-3" src="@/assets/HoverButton/main-3.svg" />
        <img class="img-4" src="@/assets/common/start_scan_large.svg" />
      </div>
      <img class="mx-auto mt-8" src="@/assets/HoverButton/arrow_up.svg" />
      <div class="tap-text mt-5 text-xs md:text-base">{{ $t('homePage.tap_to_scan') }}</div>
    </panel>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import WelcomeToScan from '@/components/Welcome/WelcomeToScan.vue';
import Panel from '@/components/common/Panel.vue';

export default {
  components: {
    WelcomeToScan,
    Panel,
  },
  methods: {
    ...mapActions('app', ['launchQrScan']),
  },
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  height: 65%;

  @screen md {
    height: 60%;
  }
}

.btn {
  @screen md {
    @apply w-56 h-56;
    transform: scale(1.5);
  }

  img {
    @apply absolute;
  }

  .img-3 {
    transform: scale(1.1);
  }
}

.icons {
  @apply absolute p-3;
  top: 5vh;
}

.menu {
  right: 1.75rem;
}

.scan-code {
  left: 1.75rem;
}

.tap-text {
  background: var(--brand-gradient-vertical);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
